import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=ad90c5d8&scoped=true&"
import script from "./savings.vue?vue&type=script&lang=js&"
export * from "./savings.vue?vue&type=script&lang=js&"
import style0 from "./savings.vue?vue&type=style&index=0&id=ad90c5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad90c5d8",
  null
  
)

export default component.exports